import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SuggestDealDialog from './SuggestDealDialog';

const Header = ({ onToggleMap }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [suggestDealOpen, setSuggestDealOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Menu items configuration
  const menuItems = [
    { text: 'Map', onClick: onToggleMap },
    { text: 'Suggest Deal', onClick: () => setSuggestDealOpen(true) },
    { text: 'Contact Us', href: 'mailto:happyhourstlv@gmail.com' },
    { text: 'Facebook', href: 'https://www.facebook.com/happyhourstlv', target: '_blank' }
  ];

  const renderMobileMenu = () => (
    <Drawer
      anchor="right"
      open={mobileMenuOpen}
      onClose={() => setMobileMenuOpen(false)}
    >
      <List sx={{ width: 250 }}>
        {menuItems.map((item) => (
          <ListItem 
            button 
            key={item.text}
            onClick={() => {
              if (item.onClick) item.onClick();
              else if (item.href) window.open(item.href, item.target || '_self');
              setMobileMenuOpen(false);
            }}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );

  return (
    <>
      {/* Single sticky header for both mobile and desktop */}
      <AppBar 
        position="sticky" 
        color="default"
        elevation={4}
      >
        <Toolbar>
          <Typography 
            variant="h6" 
            component={Link} 
            to="/" 
            sx={{ 
              flexGrow: 1, 
              textDecoration: 'none', 
              color: 'primary.main',
              fontWeight: 'bold',
            }}
          >
            Happy Hours TLV
          </Typography>
          
          {isMobile ? (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={() => setMobileMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {menuItems.map((item) => (
                <Button
                  key={item.text}
                  onClick={item.onClick}
                  href={item.href}
                  target={item.target}
                  color="inherit"
                >
                  {item.text}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile drawer menu */}
      {isMobile && renderMobileMenu()}

      <SuggestDealDialog
        open={suggestDealOpen}
        onClose={() => setSuggestDealOpen(false)}
      />

      {/* Hero section with background image */}
      <Box
        sx={{
          height: isMobile ? '350px' : '380px',
          backgroundImage: 'url(/images/cover_long.jpg)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {/* Dark overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 1,
          }}
        />

        {/* Title content centered in hero */}
        <Container maxWidth="lg" sx={{ display: 'flex', flexGrow: 1, position: 'relative', zIndex: 2 }}>
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: 'auto',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
            }}
          >
            <Typography 
              variant="h1" 
              component="h1" 
              align="center" 
              sx={{ 
                fontSize: isMobile ? '40px' : '50px', 
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              Happy Hours TLV
            </Typography>
            <Typography 
              variant="h2" 
              component="h2" 
              align="center" 
              sx={{ 
                fontSize: isMobile ? '20px' : '25px', 
                color: 'white',
                mt: 2
              }}
            >
              Your Guide To The Best Deals In Tel Aviv
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Header;